import { TreeSelect } from 'antd'
import { useStoreState } from 'easy-peasy'

import { useTranslate } from 'hooks/translate'

import Styled from './styled'

export default function SearchOrganization ({ disabled, value, onChange = () => null, style }) {
  const { t } = useTranslate()

  const filterOrganizations = useStoreState((state) => state.filter.organizations)

  const treeData = filterOrganizations
  const tProps = {
    value,
    treeCheckStrictly: false,
    allowClear: true,
    treeData,
    treeCheckable: true,
    showCheckedStrategy: TreeSelect.SHOW_PARENT,
    placeholder: t('Please search organization'),
    listHeight: 500,
    filterTreeNode: (search, item) => {
      return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
    },
    onChange: (v) => {
      onChange(v)
    },
    disabled,
    style,
  }

  return (
    <Styled className='search-organization-component'>
      <TreeSelect {...tProps} />
    </Styled>
  )
}
